/**
 * KTUI - Free & Open-Source Tailwind UI Components by Keenthemes
 * Copyright 2025 by Keenthemes Inc
 */

export { KTToggle } from './toggle';
export type { KTToggleConfigInterface, KTToggleInterface } from './types';
